import { IconButton } from '@material-ui/core';
import { IRON } from 'styles/Colors';
import { TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import PhoneNumberMask from 'components/rebrand/PhoneNumberMask';
import React, { useState } from 'react';

export default function PhoneNumberInput({
  value,
  setValue,
  disabled = false,
  clearEnabled = false
}) {
  const [focus, setFocus] = useState(false);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <TextField
      id='phoneNumber'
      name='phoneNumber'
      label='Phone Number'
      type='tel'
      css={{ width: '100%' }}
      variant='outlined'
      value={value || ''}
      onFocus={() => setFocus(true)}
      onBlur={() => {
        setFocus(false);
      }}
      FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
      InputLabelProps={{
        shrink: !!value || focus,
        style: { color: IRON }
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={{
        inputComponent: PhoneNumberMask,
        endAdornment: clearEnabled && value && (
          <IconButton onClick={() => setValue('')}>
            <ClearIcon />
          </IconButton>
        )
      }}
      onChange={handleChange}
      disabled={disabled}
    />
  );
}
